import { Observable } from 'rxjs/Observable';

import { Injectable } from '@angular/core';
import { UrlServices } from '../url.services';
import { GenericService, METHODS } from '../services.util';
import { environment } from '../../../environments/environment';
import { Form } from '../model-formulario/form';
import { DocumentModel } from 'src/app/_model/documents/models';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { URLSearchParams } from '@angular/http';

/**
 * Forms manages services
 */
@Injectable()
export class FormsService {
  @BlockUI() blockUI: NgBlockUI;

  urlServices: UrlServices = new UrlServices();


  constructor(public _genericService: GenericService) {
  }
  /**
   * Add new linking form
   * @param form obj that contain data about form
   */
  intlLatamEcMilfAddLinkingForm(document: DocumentModel): Observable<any> {
    return this._genericService.genericCallServices(METHODS.POST, this.urlServices.formContext, document, null, null);
  }
  /**
   * Get form by params
   * @param countryId Country id
   * @param brokerId Broker id
   * @param evicertia data about evicertia
   * @param status status linking form
   * @param filter filter
   */
  intlLatamEcMilfGetLinkingFormByBrokerId(countryId: string, brokerId: string,
    evicertia?: string, status?: string, filter?: string): Observable<any> {
    return this._genericService.genericCallServices(METHODS.GET, this.urlServices.urlFormsBroker + `/${brokerId}/countries/${countryId}`, null, null, null);
  }
  /**
   * Get linkinform by form id and country id
   * @param countryId country id
   * @param formId form id
   */
  intlLatamEcMilfGetLinkingFormById(countryId: string, formId: string): Observable<any> {
    return this._genericService.genericCallServices(METHODS.GET, this.urlServices.formContext + `/${formId}?country=${countryId}`, null, null, null);
  }
  /**
   * Update linking form by id
   * @param formId form id
   * @param form data that linking form
   */
  intlLatamEcMilfUpdateLinkingForm(document: DocumentModel): Observable<any> {
    return this._genericService.genericCallServices(METHODS.PUT, this.urlServices.formContext + `/`, document, null, null);
  }



  getClient(documentType: number, documentNumber: string, isParent: boolean): Observable<any> {
    return this._genericService.genericCallServices(METHODS.GET, this.urlServices.getUrlClient(documentType, documentNumber, isParent));
  }

  getDataProcessingAcceptance(documentType: number | string, documentNumber: string, rucBroker: string, ramo: string): Observable<any> {
    const url = this.urlServices.getDataProcessingAcceptanceUrl(documentType, documentNumber, rucBroker, ramo);
    return this._genericService.genericCallServices(METHODS.GET, url, null, null, null, false);
  }

  postDataProcessingAcceptance(request: any): Observable<any> {
    return this._genericService.genericCallServices(
      METHODS.POST, this.urlServices.dataProcessingAcceptance, request, null, null, false
    );
  }

  postDataProcessingCustomer(request: any): Observable<any> {
    return this._genericService.genericCallServices(
      METHODS.POST, this.urlServices.dataProcessingCustomer, request, null, null, false
    );
  }

  postClient(document: any): Observable<any> {
    return this._genericService.genericCallServices(METHODS.POST, this.urlServices.formContext+'/b2b', document, null, null);
  }

  postStateAccount(body: any) {
    return this._genericService.genericCallServices(METHODS.POST, this.urlServices.domainApiAccount+'/states/b2b', body, null, null);
  }

  async postApiGForm(body) {
    this.blockUI.start();
    const pathSend = '/document/events';
    body.type = "TICKET_SUPPORT";
    const result = await this._genericService.genericCallServices(METHODS.POST, environment.URL_API + pathSend, body, null, null, false).toPromise();
    this.blockUI.stop();
    return result
  }
}
